export default __webpack_public_path__ + "static/media/securweave logo png file (8).5fcbc60f.png";